import { z } from 'zod'
import { notificationSchema } from '../schemas/notifications.schemas'

export enum NotificationStatus {
  READ = 'read',
  UNREAD = 'unread'
}

export type Notification = z.infer<typeof notificationSchema>

export interface NotificationsPaginator {
  notifications: Notification[]
  total: number
  totalUnread: number
  pageNumber?: number
  pageSize?: number
}

export enum NotificationType {
  PLATFORM = 'platform',
  INVITATION = 'invitation',
  INVITATION_COMPANY_RECEIVED = 'invitation:company_received',
  INVITATION_COMPANY_ACCEPTED = 'invitation:company_accepted',
  INVITATION_COMPANY_REJECTED = 'invitation:company_rejected',
  INVITATION_USER_RECEIVED = 'invitation:user_received',
  INVITATION_USER_RECEIVED_ACCEPTED = 'invitation:user_received_accepted',
  INVITATION_USER_ACCEPTED = 'invitation:user_accepted',
  INVITATION_USER_REJECTED = 'invitation:user_rejected',
  ALERT = 'alert'
}
